import axios from 'axios';
import { req,reqByBlob, reqByJson } from './axiosFun';

/*
 *地块
 */
export const AllUserFieldList = (params) => { return req("post", "/fieldmanagesystem/field/queryByUserId", params) };
export const queryByPos = (params) => { return req("post", "/fieldmanagesystem/field/queryByPos", params) };
export const queryFieldsByFileIds = async (params) => { return reqByJson("post", "/fieldmanagesystem/field/queryByFileIds", params) };
export const statisticFieldByUserId = (params) => { return req("post", "/fieldmanagesystem/field/statisticByUserId", params) };

/**
 * 文件
 */
export const getFileByFileId = async (params) => { return req("post", "/fieldmanagesystem/file/getByFileId", params) };
export const searchFile = (params) => { return req("post", "/fieldmanagesystem/file/search", params) };
export const importToPlantSys = (params) => { return req("post", "/fieldmanagesystem/file/upload2PlantSystem", params) };
export const deleteByFileId = (params) => { return req("post", "/fieldmanagesystem/file/deleteByFileId", params) };
export const listFile = (params) => { return req("post", "/fieldmanagesystem/file/list", params) };
export const downloadFile = (params) => { return reqByBlob("post", "/fieldmanagesystem/file/download", params) };




// WEBPACK FOOTER //
// ./src/api/fieldMG.js